<template>
    <div>
        <Default-Layout class="contenedor-home">
            <div class="container">
                <div v-if="emailVerify">
                    <div class="title_app_home">
                        {{ $t("lang.label_my_apps") }}<br />
                        <small style="font-size: 12px"
                            >({{ $t("lang.msj_click_enter") }})</small
                        >
                    </div>
                    <div v-if="viewApps">
                        <div class="main_apps_home">
                            <div
                                class="item_home"
                                v-for="(i, index) in appsorg" :key="index"
                                @click="linkApps(i.id, index)"
                            >
                                <img
                                    class="iconapp"
                                    alt="billing"
                                    v-if="i.id == 1"
                                    src="@/assets/icon_billing.svg"
                                />
                                <img
                                    class="iconapp"
                                    alt="Website"
                                    v-else-if="i.id == 2"
                                    src="@/assets/icon_dimenu.svg"
                                />
                                <img
                                    class="iconapp"
                                    alt="Marketea"
                                    v-else
                                    src="@/assets/icon_display.svg"
                                />
                                <span>{{ i.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center" style="padding-top: 20px">
                        <div class="alert alert-warning" v-if="user_type == 0">
                            <h3>
                                {{ $t("lang.msj_org_nt_app_yet") }}<br />
                                <i class="fa fa-chevron-down"></i>
                            </h3>
                        </div>
                        <div v-else class="alert alert-warning">
                            <h3>{{ $t("lang.msj_no_org_asgnd_acct") }}</h3>
                        </div>
                    </div>
                    <hr class="separator" />
                    <div v-if="user_type == 0">
                        <div
                            class="title_app_home"
                            style="margin: 30px 0px 10px 0px !important"
                        >
                            {{ $t("lang.label_app_availatable") }}<br />
                            <small style="font-size: 12px">{{
                                $t("lang.msj_time_intl")
                            }}</small>
                        </div>

                        <div class="main_apps_home install" style="padding-top: 0px">
                            <div class="item_home install" v-for="(i, index) in listAvailableApps" :key="index">
                                <img
                                    class="iconapp"
                                    alt="billing"
                                    v-if="i.id == 1"
                                    src="@/assets/icon_billing.svg"
                                />
                                <img
                                    class="iconapp"
                                    alt="Website"
                                    v-else-if="i.id == 2"
                                    src="@/assets/icon_dimenu.svg"
                                />
                                <img
                                    class="iconapp"
                                    alt="Marketea"
                                    v-else
                                    src="@/assets/icon_display.svg"
                                />                                
                                <!-- <span>{{i.name}}</span>-->
                                <div class="btnapps">
                                    <a
                                        href="javascript:"
                                        class="btn btn-success btn-sm btn_custom2"
                                        @click="AssignApp(i)"
                                        >{{ $t("lang.label_intl") }}</a
                                    >
                                    <a
                                        href="https://marketea.com"
                                        class="btn btn-info btn-sm btn_custom1"
                                        target="_blank"
                                        >{{ $t("lang.label_learn_more") }}...</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="text-center" style="padding-top: 60px">
                    <div class="alert alert-emailverify">
                        <h3>
                            <i class="fa fa-exclamation-triangle"></i>
                            {{ $t("lang.msj_verify_email") }}<br />
                            <i class="fa fa-chevron-down"></i><br />
                            <button
                                type="submit"
                                class="btn btn-dark"
                                style="width: 200px"
                                @click="resendEmailToken"
                            >
                                {{ $t("lang.msj_email_vrifiction") }}
                            </button>
                        </h3>
                    </div>
                </div>
            </div>
            <div id="loadingHome" class="alert" v-if="isLoading">
                <i class="fas fa-spinner fa-spin fa-3x"></i>
            </div>
        </Default-Layout>
        <modal name="modal-setting" height="auto" @before-close="ClosedModal">
            <div class="card">
                <component :is="SettingBox" :items="DataMail"></component>
            </div>
        </modal>
        <modal name="modal-app-install" height="auto" :width="350">
            <div class="card-header text-center" style="font-size: 20px">
                {{ $t("lang.label_intl") }}
                <button @click="closeModal" class="closeIcon"><span></span></button>
            </div>
            <div class="card-body text-center">
                <form @submit.prevent="InstallApps">
                    <div class="media">
                        <!-- <img :src="iconapp" class="mr-3" alt="" style="width: 70px;"> -->
                        <div class="media-body">
                            <h5 class="mt-0">{{ name }} {{ $t("lang.label_app") }}</h5>
                            <em>{{ description }} </em><br /><br />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12">
                            <!-- <label for="exampleFormControlSelect1">Org. Name</label> -->
                            <select
                                class="form-control"
                                id="exampleFormControlSelect1"
                                v-model="org_id"
                                style="display: none"
                            >
                                <option
                                    :value="i.id"
                                    v-for="i in organizationslist"
                                    :key="i.id"
                                >
                                    {{ i.bill_company_name }}
                                </option>
                            </select>
                            <button
                                type="submit"
                                class="btn btn-success"
                                style="width: 100%"
                            >
                                {{ $t("lang.msj_agree_intl") }}
                            </button>
                        </div>
                        <div class="col" style="display: none">
                            <!-- <label for="exampleFormControlSelect1">.</label> -->
                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click="closeModal"
                                style="width: 100%"
                            >
                                <i class="fas fa-times"></i> {{ $t("lang.label_cancel") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
    name: "Home",
    components: {
        DefaultLayout,
    },
    data () {
        return {
            viewApps: true,
            listApps: [],
            isLoading: false,
            SettingBox: "",
            DataMail: [],
            organizationslist: [],
            listAvailableApps: [],
            name: null,
            app_id: null,
            org_id: window.localorgdata,
            description: null,
            iconapp: null,
            emailVerify: true,
            user_type: window.user_type,
        }
    },
    created () {
        this.$store.dispatch("validToken").then((response) => {
            window.emailVerify = response.data.emailVerify;
            this.emailVerify = response.data.emailVerify;
            if (response.data.tokenValid && response.data.emailVerify) {
                this.getOrganizations();
                this.listadoApps();
            } else {
                this.$router.push({ name: "Logout" });
            }
        });
    },
    methods: {
        InstallApps() {
            window.master
                .put("assignapp/add/" + window.localAccountID, {
                    user_id: window.localAccountID,
                    org_id: this.org_id,
                    app_id: this.app_id,
                })
                .then((response) => {
                    this.$modal.hide("modal-app-install");
                    if (window.user_type == 0) {
                        this.$store
                            .dispatch("ListAppsbyOrg", window.localorgdata)
                            .then((response) => {
                                this.isloaing = false;
                            });
                    } else {
                        this.$store
                            .dispatch("ListAppsForOrgOfSecondary", window.localorgdata)
                            .then((response) => {
                                this.isloaing = false;
                            });
                    }
                    this.listadoApps();
                })
                .catch((error) => console.log(error, (this.isloaing = false)));
        },
        ClosedModal() {
            this.SettingBox = "";
        },
        AssignApp(i) {
            this.name = i.name;
            this.app_id = i.id;
            this.description = i.description;
            this.$modal.show("modal-app-install");
        },
        closeModal() {
            this.$modal.hide("modal-app-install");
        },

        getOrganizations() {
            this.organizationslist = this.$store.getters.getListOrgs;
        },
        listadoApps() {
            let org = localStorage.getItem("mark_client_data");
            if (org > 0) {
                window.master
                    .get("getapp/" + org)
                    .then((response) => {
                        let r = response.data.r; // listado de app disponibles
                        if (r.length > 0) {
                            this.viewApps = true;
                        } else {
                            this.viewApps = false;
                        }
                        this.listApps = r;
                        //console.log('app instaladas',this.listApps);
                        this.getAppsList();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        getAppsList() {
            window.master
                .get("appslist/" + window.localorgdata)
                .then((response) => {
                    console.log(response.data);
                    let r = response.data.r;
                    let result = r.filter((item) => {
                        let ok = true;
                        for (let i = 0; i < this.listApps.length && ok; i++) {
                            let c = this.listApps[i];
                            if (c["id"] == item["id"]) ok = false;
                        }
                        return ok;
                    });
                    this.listAvailableApps = result;
                })
                .catch((error) => console.log(error));
        },
        linkApps(app_id, index) {
            this.isLoading = true;
            let a = localStorage.getItem("access_token");
            let o = localStorage.getItem("oauth");
            let u = localStorage.getItem("mark_client_data");
            let org = localStorage.getItem("mark_client_data");
            window.master
                .get("getappid/" + org + "/" + app_id)
                .then((response) => {
                    let r = response.data.r;
                    let nomApp = r.name;
                    localStorage.setItem("menu_top_active", index);
                    localStorage.setItem("applive", app_id);
                    // console.log('app= '+nomApp, 'iD= '+app_id);
                    this.$store.dispatch("apps_modulos", app_id).then((response) => {
                        this.$store.dispatch("SET_APP_ID", app_id);
                        if (app_id == 2) {
                            this.$router.push({ name: "Menu" });
                        } else {
                            this.$router.push({ name: nomApp });
                        }
                    });
                    //this.isLoading=false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    //debugger;
                });
        },
        resendEmailToken() {
            this.isLoading = true;
            window.master
                .post("pushtetokenemail", {
                    user_id: window.localAccountID,
                })
                .then((response) => {
                    if (response.data.status) {
                        this.$swal.fire({
                            type: "success",
                            title: window.lang2.msj_vrifiction_email,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    } else {
                        this.$swal.fire({
                            type: "error",
                            title: window.lang2.msj_err_sndng_email,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.$swal.fire({
                        type: "error",
                        title: window.lang2.msj_internal_err,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                });
        },
    },
    computed: {
        ...mapGetters({ appsorg: "applistorgs" }),
    },
}
</script>

<style lang="scss" scoped>
.btnapps {
    display: flex;
    flex-direction: column;
    margin-top: 11px;
}
.btn_custom1 {
    display: block;
    position: relative;
    padding: 2px 4px;
    margin-right: 3px;
    width: 85px;
    border-radius: 40px;
    border: 0px solid #000;
    color: #000;
    font-size: 13px;
    background: transparent;
    height: 29px !important;
    vertical-align: middle;
    padding: 10px;
    line-height: 11px;
}
.btn_custom1:hover,
.btn_custom1:focus,
.btn_custom1:active {
    background-color: transparent !important;
    border-color: transparent !important;
    color: #000 !important;
    box-shadow: none;
}
.btn_custom2 {
    display: block;
    position: relative;
    padding: 2px 4px;
    width: 85px;
    font-size: 13px;
    border-radius: 40px;
    color: #fff;
    background-color: #019720 !important;
    border: 1px solid #019720 !important;
    height: 31px !important;
    padding: 10px;
    line-height: 11px;
    vertical-align: middle;
    margin-bottom: 10px;
}
.title_app_home {
    position: relative;
    display: block;
    margin-top: 61px !important;
    font-size: 23px;
    font-weight: normal;
    color: #6f6f6f;
    text-align: center;
    font-weight: bold;
    line-height: 1;
}
.title_app_home:after {
    content: "";
    width: 40px;
    height: 3px;
    background-color: #019720;
    margin: 0 auto;
    display: block;
    margin-top: 5px;
}
.main_apps_home {
    display: flex;
    margin: 0 auto;
    padding-top: 10px;
}
.main_apps_home,
.main_apps_home .item_home {
    display: flex;
    align-items: center;
    justify-content: center;
}
.main_apps_home .item_home {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 8rem;
    height: 7rem;
    margin: 1%;
    border-radius: 10px;
    border: 0px solid #aaa;
    cursor: pointer;
    margin-bottom: 18px;
    text-align: center;
    padding: 10px;
    transition: 0.7s;
}
.main_apps_home .item_home img {
    display: block;
    transition: 0.5s;
}
.main_apps_home .item_home span {
    display: block;
    text-transform: uppercase;
    padding-top: 3px;
    width: 100%;
    transition: transform 0.2s;
}
.main_apps_home .item_home:hover {
    border: 0px solid #ccc;
}
.main_apps_home .item_home:hover img {
    opacity: 1;
}
.main_apps_home .item_home:hover span {
    transform: scale(1.2);
}
.main_apps_home .item_home.install .iconapp,
.main_apps_home .item_home .iconapp {
    width: 100px;
    height: auto;
}
#loadingHome {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
    border-radius: 0px;
    justify-content: center;
    align-items: center;
    display: flex;
}
.separator {
    width: 50%;
    max-width: 800px;
    border-color: #cecece;
    margin-top: 0.15rem;
    margin-bottom: 0rem;
}
.main_apps_home .item_home.install {
    background: transparent;
    border: 0px solid #fff !important;
    padding-bottom: 0;
    padding-top: 0;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    height: 187px;
}
.alert-emailverify {
    color: #fff;
    background-color: #f1924f;
    border-color: #ef8031;
}
.contenedor-home {
    position: relative;
    height: 100vh;
}
@media (max-width: 767px) {
    .main_apps_home {
        display: flex;
        width: 17rem;
        height: auto;
        margin: 0px auto;

        display: flex;
        flex-wrap: wrap;
    }
    .main_apps_home .item_home {
        flex: 0 0 45%;
        max-width: 45%;
        flex-direction: column;
    }
    .main_apps_home.install {
        flex-direction: column;
    }
    .main_apps_home .item_home.install {
        margin-bottom: 20px !important;
        width: 17rem;
        height: 10rem;
        flex: 0 0 70%;
        max-width: 70%;
    }
}
.closeIcon {
    height: 40px;
    width: 40px;
}
.closeIcon span:before,
.closeIcon span:after {
    width: 30px;
}
</style>
